import type { NavigationGuard } from 'vue-router'
import { routeNames } from '@/router/route-names'

export const authGuard: NavigationGuard = async (to, _from, next) => {
  const authStore = useAuthStore()
  const isAuthenticated = await authStore.getToken()

  // Try to fetch user is token exist
  if (isAuthenticated && !authStore.user) {
    try {
      await authStore.getUserProfile()
    } catch (e) {
      console.error('Error in auth guard: user not available')
    }
  }

  // If not logged in and goes to restricted route
  if (!authStore.user && !to.meta.notRequireAuth) {
    return next({ name: routeNames.login })
  }

  if (authStore.user && to.path.includes('auth')) {
    return next('/')
  }

  next()
}
